<template>
  <div>
    <Layout :pagetitle="$t('Rewards')">
      <form autocomplete="off" @submit.prevent="saveReward">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Reward') }}</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col class="mt-2" md="4">
              <label>{{ $t('Name') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="name" />
            </b-col>
            <b-col class="mt-2" md="4">
              <label>{{ $t('Product Type') }}</label>
              <productTypeSelector :modelValue="idProductType" @onChange="setProductType" />
            </b-col>
            <b-col class="mt-2" md="4">
              <label>{{ 'Slug' }}</label>
              <Multiselect
                class="multiselect-custom-input"
                v-model="slug"
                :close-on-select="true"
                :searchable="true"
                :options="slugOptions"
              />
            </b-col>

            <b-col class="mt-2" md="3">
              <label>{{ $t('Fixed Reward') }}</label>
              <b-form-input type="number" autocomplete="off" step="0.01" required v-model="fixedReward" />
            </b-col>
            <b-col class="mt-2" md="3">
              <label>
                {{ $t('Dynamic Reward') }}
                <i
                  class="text-secondary mdi mdi-information"
                  :title="$t('Utilize as palavras reservadas')"
                  v-b-popover.hover="`${$utils.expressionKeywords.join(', ')}`"
                />
              </label>
              <b-form-input :trim="true" autocomplete="off" :required="!isCpa" v-model="dynamicReward" />
            </b-col>

            <b-col class="mt-2" md="3">
              <label>
                {{ $t('Admin Fee') }}
                <i
                  class="text-secondary mdi mdi-information"
                  :title="$t('Utilize as palavras reservadas')"
                  v-b-popover.hover="`${$utils.expressionKeywords.join(', ')}`"
                />
              </label>
              <b-form-input :trim="true" autocomplete="off" v-model="adminFee" />
            </b-col>
            <b-col class="mt-2" md="3">
              <label>{{ $t('Percentage') }}</label>
              <b-form-input type="number" autocomplete="off" step="0.01" required v-model="percentage" />
            </b-col>

            <b-col class="mt-2" md="4" v-if="isCpa">
              <label>{{ $t('Trigger (condition)') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="trigger.condition" />
            </b-col>
            <b-col class="mt-2" md="4" v-if="isCpa">
              <label>{{ $t('Trigger (operation)') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="trigger.operation" />
            </b-col>
            <b-col class="mt-2" md="4" v-if="isCpa">
              <label>{{ $t('Trigger (comparison)') }}</label>
              <b-form-input type="number" autocomplete="off" step="0.01" required v-model="trigger.comparison" />
            </b-col>
          </b-row>
        </b-card>
        <b-row>
          <div>
            <button
              type="submit"
              class="btn btn-primary m-1"
              v-if="$route.params.id"
              :disabled="$store.state.isLoading"
            >
              {{ $t('Update') }}
            </button>
            <button type="submit" class="btn btn-primary m-1" :disabled="$store.state.isLoading" v-else>
              {{ $t('Create') }}
            </button>
            <button type="button" class="btn btn-secondary m-1" @click="$router.back()">
              {{ $t('Back') }}
            </button>
          </div>
        </b-row>
      </form>
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import productTypeSelector from '@/components/selectors/productTypeSelector.vue';
import Multiselect from '@vueform/multiselect';

export default {
  components: { Layout, productTypeSelector, Multiselect },
  data() {
    return {
      name: '',
      slug: '',
      idProductType: null,
      idCompany: null,
      fixedReward: 0,
      dynamicReward: '',
      adminFee: '',
      trigger: {
        condition: '',
        operation: '',
        comparison: 0
      },
      percentage: 0,
      subType: '',
      slugTemp: '',
      slugOptions: []
    };
  },
  computed: {
    isCpa() {
      return this.idProductType == 4;
    }
  },
  mounted() {
    if (this.$route.params?.id) {
      this.getReward();
    }
  },
  methods: {
    saveReward() {
      if (this.$route.params?.id) {
        this.updateReward();
      } else {
        this.createReward();
      }
    },
    getReward() {
      const rewardId = this.$route.params.id;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/reward/${rewardId}`, {})
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let reward = res.data;

          this.name = reward.name;
          this.slug = reward.slug;
          this.idProductType = reward.id_product_type;
          this.idCompany = reward.id_company;
          this.fixedReward = reward.fixed_reward;
          this.dynamicReward = reward.dynamic_reward;
          this.adminFee = reward.admin_fee;
          this.percentage = reward.percentage ? parseFloat(reward.percentage) * 100 : 0;
          this.subType = reward.sub_type;
          this.trigger = reward?.trigger || {
            condition: '',
            operation: '',
            comparison: 0
          };

          this.slugTemp = reward.slug;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: this.$t('Error')
          });
        });
    },
    createReward() {
      if (!this.validateReward()) return;
      let reward = {
        name: this.name,
        slug: this.slug,
        idProductType: this.idProductType,
        idCompany: this.idCompany,
        fixedReward: this.fixedReward,
        dynamicReward: this.dynamicReward,
        adminFee: this.adminFee || '0',
        percentage: this.percentage / 100,
        subType: this.subType,
        trigger: this.trigger
      };

      if (reward?.dynamicReward) {
        reward.dynamicReward = reward.dynamicReward.replaceAll(',', '.');
      }

      if (reward?.adminFee) {
        reward.adminFee = reward.adminFee.replaceAll(',', '.');
      }

      if (!this.isCpa) {
        reward.trigger = null;
      }

      this.$store.commit('SET_LOADING', true);

      this.$api
        .post('api/reward', reward)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });

          this.$router.push({
            name: 'rewardList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Create reward error')
          });
        });
    },
    updateReward() {
      if (!this.validateReward()) return;
      let rewardId = this.$route.params.id;
      let reward = {
        name: this.name,
        slug: this.slug,
        idProductType: this.idProductType,
        idCompany: this.idCompany,
        fixedReward: this.fixedReward,
        dynamicReward: this.dynamicReward,
        adminFee: this.adminFee || '0',
        percentage: this.percentage / 100,
        subType: this.subType,
        trigger: this.trigger
      };

      if (reward?.dynamicReward) {
        reward.dynamicReward = reward.dynamicReward.replaceAll(',', '.');
      }

      if (reward?.adminFee) {
        reward.adminFee = reward.adminFee.replaceAll(',', '.');
      }

      if (!this.isCpa) {
        reward.trigger = null;
      }

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/reward/${rewardId}`, reward)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.$router.push({
            name: 'rewardList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Update reward error')
          });
        });
    },
    setProductType(idProductType) {
      this.idProductType = idProductType;
      this.setSlugOptions();

      if (this.isCpa) {
        this.subType = 'mark';
      } else {
        this.subType = 'accumulative';
      }

      if (this.$route.params.id && this.slugTemp) {
        this.slug = `${this.slugTemp}`;
        this.slugTemp = '';
      }
    },
    setSlugOptions() {
      this.slug = '';
      //CPA
      if (this.idProductType == 4) {
        this.slugOptions = [
          // { value: 'cpa-fisrt-deposit', label: 'cpa-fisrt-deposit' },
          // { value: 'cpa-register', label: 'cpa-register' },
          { value: 'cpa-total-turnover', label: 'cpa-total-turnover' },
          { value: 'cpa-total-deposit', label: 'cpa-total-deposit' }
        ];
        return;
      }

      //GAMES
      if (this.idProductType == 3) {
        this.slugOptions = [{ value: 'games', label: 'games' }];
        return;
      }

      //LOTTERY
      if (this.idProductType == 2 || this.idProductType > 4) {
        this.slugOptions = [{ value: 'lotto', label: 'lottery' }];
        return;
      }

      //BETS
      if (this.idProductType == 1) {
        this.slugOptions = [{ value: 'bets', label: 'bets' }];
        return;
      }

      this.slugOptions = [];
    },
    validateReward() {
      if (!this.name) {
        this.$customAlert({
          msg: this.$t('Invalid name'),
          type: 'error'
        });
        return false;
      }
      if (!this.idProductType) {
        this.$customAlert({
          msg: this.$t('Invalid product type'),
          type: 'error'
        });
        return false;
      }
      if (!this.slug) {
        this.$customAlert({
          msg: this.$t('Invalid slug'),
          type: 'error'
        });
        return false;
      }
      if (this.trigger?.condition) {
        if (this.trigger.condition.includes('=>') || this.trigger.condition.includes('= >')) {
          this.$customAlert({
            msg: this.$t('Type the correct conditional symbol (>=)'),
            type: 'error'
          });
          return false;
        }
      }
      if (this.dynamicReward && !this.$utils.expressionValidade(this.dynamicReward)) {
        this.$customAlert({
          msg: this.$t('Invalid dynamic reward expression'),
          type: 'error'
        });
        return false;
      }
      if (this.adminFee && !this.$utils.expressionValidade(this.adminFee)) {
        this.$customAlert({
          msg: this.$t('Invalid admin fee expression'),
          type: 'error'
        });
        return false;
      }
      return true;
    }
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
